import { Box } from "@mui/material";
import logo from "../../assets/images/logo_light.svg";

function Header() {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        height: '100px'
      }}
    >
      <Box component="img" src={logo} sx={{width: '140px'}} />
    </Box>
  );
}

export default Header;
